/**
 * This constants describe all nav menu state.
 */
export enum MenuStates {
    OPEN = 'open',
    CLOSE = 'closed',
}
